export const TEXT_LIST = {
	// WizardSteps
	StepInvoice: "Invoice",
	StepBilling: "Billing",
	StepPayment: "Payments",
	StepReview: "Review",

	// Invoice Details Page
	InvoiceDetails: "Invoice Details",
	FinalDetails: "Final Invoice Details",
	DepositDetails: "Deposit Details",
	InvoiceDetailsHint: "Please confirm your Invoice ID and amount and proceed with payment below.",
	FinalDetailsHint: "Please confirm your Invoice ID, final invoice amount, and proceed with payment below",
	DepositDetailsHint: "Please confirm your Invoice ID, deposit amount, and proceed with payment below",
	InvoiceIdPlaceholder: "Ex. 10001234",
	InvoiceId: "Invoice ID",
	InvoiceAmount: "Invoice Amount",
	YourCountry: "Your Country",
	YourCurrency: "Your Currency",
	SelectCountry: "Select Country",
	SelectCurrency: "Select Currency",
	AmountPayable: "Amount Payable",
	NoExchangeRate: "No exchange found...",

	// Billing Address Page
	BillingAddress: "Billing Address",
	FullName: "Full Name",
	EmailAddress: "Email Address",
	Address: "Address",
	City: "City",
	Region: "State / Province",
	SelectRegion: "Select Region",
	Country: "Country",
	PostalCode: "Postal Code",
	PhoneNumber: "Phone Number",
	NationalIdentifier: "National Identifier",
	BirthDate: "Birth Date",

	// Payments Page
	PayWithCard: "Pay with Credit Card",
	CardNumber: "Card Number",
	CardType: "Card Type",
	SecurityCode: "Security Code",
	CardholderName: "Cardholder Name",
	ExpirationMonth: "Expiration Month",
	ExpirationYear: "Expiration Year",
	NoCardOtherMethods: "Select one of the following payment methods:",
	OtherMethods: "Or, select one of the following payment methods:",
	FinancingDetails: "Financing Details",
	FinancingSelect: "I would like to finance this transaction",
	NoFinancing: "No Financing Selected",
	FinanceTemplate: "Pay {0} over {1} Months ({2}% Interest)",
	BankAdditional: "Additional information is required:",
	SelectInstitution: "Please select your bank / financial institution",
	PleaseSelectBank: "Select Bank",

	// Review Screen
	ReviewPayment: "Review your Payment",
	PaymentDetails: "Payment Details",
	CardExpiry: "Expiry",
	OnlinePayment: "Online Payment",
	OnlinePaymentHint: "You will be redirected to {0} to complete payment",
	OfflinePayment: "Offline Payment",
	OfflinePaymentHint: "You will be provided with details required to complete payment.",
	BankInstitution: "Bank / Institution",
	OtherDetails: "Other Details",
	PaymentSummary: "Payment Summary",
	ExchangeRate: "Exchange Rate",
	Subtotal: "Subtotal",
	Instalments: "Instalments",
	FinancingFees: "Financing Fees",
	ProcessingFees: "Processing Fees",
	Total: "Total Payment",
	BadgeText: "By completing your order, you will checkout with Reach, {0}'s international seller partner and agree to the",
	TermsOfService: "Terms of Service",
	PaymentProcessing: "Your payment is being processed.",

	// Action Handlers
	ChallengeHeader: "Bank Verification",
	ChallengeLoadingMessage: "Loading... please wait!",
	RedirectHeader: "Redirecting...",
	RedirectLoadingMessage: "Please wait, you will be redirected to complete your payment.",
	DisplayHeader: "Bank Transfer Details",
	BankName: "Bank",
	AccountName: "Account Name",
	PaymentReference: "Reference",
	AccountNumber: "Account #",
	Amount: "Amount",
	BankData: "Bank Info",
	AbaRoutingNumber: "ABA Routing Number",
	Iban: "IBAN",
	SortCode: "Sort Code",
	SwiftCode: "Swift Code",
	Location: "Location",
	ViewStatus: "View Status",

	// Confirmation Page
	PaymentSuccess: "Payment Successful!",
	PaymentPending: "Payment Pending...",
	PaymentFailed: "Payment Failed!",
	ReferenceId: "Reference #",
	TransactionDate: "Date",
	PaymentMethod: "Payment Method",
	NoPaymentMethod: "No Payment Found",
	PaymentStatus: "Payment Status",
	UpdatedStatusRefresh: "Refresh the page to view updated status...",
	QuestionsContact: "If you have any questions about this payment, please contact",
	PrintRequest: "Please print this page for your records.",
	TransactionLoadingHeader: "Please wait...",
	TransactionLoadingText: "We are trying to load your payment information",

	// General
	HeaderText: "Invoice Payment",
	NeedHelp: "Need Help?",
	NextStep: "Next Step",
	StartOver: "Start Over",
	PayNow: "PAY NOW!",
	ErrorHeader: "We've caught an error!",
	ErrorHint: "A system error occured! Please contact an administrator! Error details are:",
	WarningHeader: "Please contact the Merchant!",
	WarningHint: "An issue occured while attempting to pay. Issue details are:",
	LoadingHeader: "Loading",
	LoadingMessage: "Invoice is Loading...",

	// Invalid Order
	OrderNotFound: "Invalid Payment ID",
	OrderNotFoundText: "The payment you are trying to view could not be found in our system. Please contact an adminstrator or try again later.",

	// Fallback string
	NotFound: "Not Found!"
};
